import { ButtonWithIcon, CardSkeletonLoader, Modal } from '@/components/atoms'
import { SaveCancelFooter, SectionTitle } from '@/components/molecules'
import { PageContainer } from '@/components/organisms'
import useActivityReview from '@/containers/Activity/ActivityReview/ActivityReview-hook'
import { handleGetActivity } from '@/services/activities'
import { useAppSelector, useAppDispatch } from '@/store'
// import { WARNING_MESSAGE } from '@/types/Activity'

import {  setToastNotifications } from '@/store/slices/commonSlice'
import { getFormattedDate } from '@/utils/commons'
import { COLOR } from '@/utils/constants/colors'
import { localCurrencyText } from '@/utils/constants/commonConstants'
import { MODAL_TYPE, SIZE } from '@/utils/constants/globalStyle'
import { useEffect, useCallback, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import {validate} from 'uuid';

import { setActivityFormData} from '@/store/slices/activitySlice'
const ActivityReviewField = ({ label, value }) => {

  let displayValue = value;
  const upperCaseLabels = ['Activity Type', 'Receive Points', 'Frequency','Order Type', 'Activity Name']
  if ( upperCaseLabels.includes(label)) {
    displayValue = value?.toUpperCase()
  }
  if (label === 'Start Date' || label === 'End Date') {
    displayValue = getFormattedDate(value, false, '-', 'yyyy-mm-dd')
  }
  return (
    <>
      {label === 'Start Date' && <SectionTitle label={'Availability'} />}
      {label === 'Local Currency' && <SectionTitle label={'Point Allocation'} />}
      {label === 'Number Of Cases' && <SectionTitle label={'Point Allocation (Number Of Cases)'} />}
      <div className="mt-4 flex w-full border-b border-gray-700 pb-2 md:w-1/2">
        <div className="w-1/2">
          <p className="pl-1 text-sm text-[#D0D0D0]">{label}</p>
        </div>
        <div className="w-1/2">
          <p className="pl-1 font-bold text-white">{displayValue}</p>
        </div>
      </div>
    </>
  )
}

const ActivityReview = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { id } = useParams(); 
  const [loading, setLoading] = useState(false);
  const {getFormDataWithOrder} = useActivityReview()
  const getActivity = useCallback(async (id) => {
    try {
      const paramKey = validate(id) ? 'uuid' : 'id';
      setLoading(true)
      dispatch(setActivityFormData({})); // Reset form data before fetching new activity
     
      const response = await handleGetActivity(`${paramKey}=${id}`, false);
      setLoading(false)
      if (response?.data.success) {
        dispatch(setToastNotifications({ show: true, message: 'Activity data fetched successfully', type: 'success' }))
        if(response?.data?.content?.length>0){
          const data = response?.data?.content[0].versionData;
          dispatch(setActivityFormData({...getFormDataWithOrder(data), status: data.status}));
        }
      }else if( response?.data){
        dispatch(setToastNotifications({ show: true, message: 'Activity data fetched successfully', type: 'success' }))
        dispatch(setActivityFormData({...getFormDataWithOrder(response?.data), status: response?.data.status}));
      }
       else {
         dispatch(setToastNotifications({ show: true, message: 'Failed to fetch activity data', type: 'error' }))
        console.error('Failed to fetch activity data:', response?.message);
      }
    } catch (error) {
      setLoading(false)
      console.error('Error fetching activity data:', error);
    }
  },[dispatch, getFormDataWithOrder]);
  useEffect(()=>{
    if(id)
      getActivity(id);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  const {
    handlePublish,
    handleDraft,
    handleCancel,
    onClickPrimaryButton,
    onClickSecondaryButton,
    isCancel,
    activityFormData,
  } = useActivityReview()
  const localCurrency = useAppSelector(state => state.common.localCurrency)
  return (
    <>
    
      <PageContainer data-testid="activity-review" minHeight={'65vh'}>
      { loading && <CardSkeletonLoader count={3}/>}
      {!loading && <>
        <div data-testid="activity-review-content" className="flex items-center justify-between">
          <SectionTitle label={'Activity Setup'} />
          <ButtonWithIcon
            uiSchema={{
              className: 'ml-8 flex items-center text-sm text-[#0069D7] border-none',
              title: 'Edit',
              size: SIZE.SMALL,
              variant: COLOR.TERTIARY,
              isDark: true,
            }}
            iconLeading="edit"
            handleButton={() => navigate('/rewards/activity/add')}
          />
        </div>
        <>
          {Object.entries(activityFormData)
            .filter(([key]) => key !== 'hasEndDate' &&  key!=='status')
            .map(([key, value]) => (
              <ActivityReviewField
                key={key}
                label={key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                value={key === localCurrencyText && value ? `${value} ${localCurrency}` : value || ''}
              />
            ))}

          {isCancel ? (
            <Modal
              type={MODAL_TYPE.FLUID}
              showModal={isCancel}
              onCloseModal={handleCancel}
              title="Are you sure you want to cancel?"
              text={
                'Your work will not be saved if you click Yes. To continue editing and go back to the page, click NO'
              }
              showPrimaryButton={true}
              primaryButtonText="Yes"
              onClickPrimaryButton={onClickPrimaryButton}
              showSecondaryButton={true}
              secondaryButtonText="No"
              onClickSecondaryButton={onClickSecondaryButton}
              footerProps={{
                size: 'medium',
                type: 'primary',
              }}
              isDark={true}
            />
          ) : null}
        </>
        </>
  }
      {/* <WarningLabel title={WARNING_MESSAGE.SCHEDULING_CONFLICT_DETECTED} /> */}
      </PageContainer>
      {activityFormData.status?.toUpperCase()!='PUBLISHED' &&
      <SaveCancelFooter
        isReview={true}
        handleCancel={handleCancel}
        nextAction={handlePublish}
        draftAction={handleDraft}
      />}
    </>
  )
}

export default ActivityReview
